export const GET_VENDOR_EVENTS = 'GET_VENDOR_EVENTS';
export const FIND_VENDOR_EVENT_REGISTERED = 'FIND_VENDOR_EVENT_REGISTERED';
export const GET_VENDOR_EVENTS_SUCCESS = 'GET_VENDOR_EVENTS_SUCCESS';
export const GET_VENDOR_EVENTS_FAILED = 'GET_VENDOR_EVENTS_FAILED';

export const GET_VENDOR_EVENTS_WITHOUT_FILTERS = 'GET_VENDOR_EVENTS_WITHOUT_FILTERS';
export const GET_VENDOR_EVENTS_WITHOUT_FILTERS_SUCCESS =
  'GET_VENDOR_EVENTS_WITHOUT_FILTERS_SUCCESS';
export const GET_VENDOR_EVENTS_WITHOUT_FILTERS_FAILED = 'GET_VENDOR_EVENTS_WITHOUT_FILTERS_FAILED';

export const REGISTER_VENDOR_EVENT = 'REGISTER_VENDOR_EVENT';
export const REGISTER_VENDOR_EVENT_SUCCESS = 'REGISTER_VENDOR_EVENT_SUCCESS';
export const REGISTER_VENDOR_EVENT_FAILED = 'REGISTER_VENDOR_EVENT_FAILED';
export const VENDOR_EVENT_NOT_REGISTERED = 'VENDOR_EVENT_NOT_REGISTERED';

export const SET_VENDOR_EVENT_PAYLOAD = 'SET_VENDOR_EVENT_PAYLOAD';

export const UPDATE_APPLICATION_STATUS = 'UPDATE_APPLICATION_STATUS';
export const UPDATE_APPLICATION_STATUS_SUCCESS = 'UPDATE_APPLICATION_STATUS_SUCCESS';
export const UPDATE_APPLICATION_STATUS_FAILED = 'UPDATE_APPLICATION_STATUS_FAILED';

export const CREATE_STRIPE_CHECKOUT_SESION = 'CREATE_STRIPE_CHECKOUT_SESION';
export const CREATE_STRIPE_CHECKOUT_SESION_SUCCESS = 'CREATE_STRIPE_CHECKOUT_SESION_SUCCESS';
export const CREATE_STRIPE_CHECKOUT_SESION_FAILED = 'CREATE_STRIPE_CHECKOUT_SESION_FAILED';

export const CREATE_EVENT_APPLICATION = 'CREATE_EVENT_APPLICATION';
export const CREATE_EVENT_APPLICATION_SUCCESS = 'CREATE_EVENT_APPLICATION_SUCCESS';
export const CREATE_EVENT_APPLICATION_FAILED = 'CREATE_EVENT_APPLICATION_FAILED';

export const SET_TOTAL_AMOUNT_DUE = 'SET_TOTAL_AMOUNT_DUE';
export const RESET_VENDOR_EVENT = 'RESET_VENDOR_EVENT';

export const GET_VENDOR_EVENTS_BY_EVENT = 'GET_VENDOR_EVENTS_BY_EVENT';
export const GET_VENDOR_EVENTS_BY_EVENT_SUCCESS = 'GET_VENDOR_EVENTS_BY_EVENT_SUCCESS';
export const GET_VENDOR_EVENTS_BY_EVENT_FAILED = 'GET_VENDOR_EVENTS_BY_EVENT_FAILED';

export const GET_ALL_VENDOR_EVENTS = 'GET_ALL_VENDOR_EVENTS';
export const GET_ALL_VENDOR_EVENTS_SUCCESS = 'GET_ALL_VENDOR_EVENTS_SUCCESS';
export const GET_ALL_VENDOR_EVENTS_FAILED = 'GET_ALL_VENDOR_EVENTS_FAILED';

export const CANCEL_EVENT_REGISTRATION = 'CANCEL_EVENT_REGISTRATION';
export const CANCEL_EVENT_REGISTRATION_SUCCESS = 'CANCEL_EVENT_REGISTRATION_SUCCESS';
export const CANCEL_EVENT_REGISTRATION_FAILED = 'CANCEL_EVENT_REGISTRATION_FAILED';

export const ON_SEARCH_VENDORS_EVENT = 'ON_SEARCH_VENDORS_EVENT';
export const ON_SEARCH_ALL_VENDORS_EVENT = 'ON_SEARCH_ALL_VENDORS_EVENT';

export const GET_REFUNDS = 'GET_REFUNDS';
export const GET_REFUNDS_SUCCESS = 'GET_REFUNDS_SUCCESS';
export const GET_REFUNDS_FAILED = 'GET_REFUNDS_FAILED';

export const REFUND = 'REFUND';
export const REFUND_SUCCESS = 'REFUND_SUCCESS';
export const REFUND_FAILED = 'REFUND_FAILED';

export const CREATE_REFUND_REQUEST = 'CREATE_REFUND_REQUEST';
export const CREATE_REFUND_REQUEST_SUCCESS = 'CREATE_REFUND_REQUEST_SUCCESS';
export const CREATE_REFUND_REQUEST_FAILED = 'CREATE_REFUND_REQUEST_FAILED';

export const GET_VENDOR_UNPAID_EVENT_REGISTRATIONS = 'GET_VENDOR_UNPAID_EVENT_REGISTRATIONS';
export const GET_VENDOR_UNPAID_EVENT_REGISTRATIONS_SUCCESS =
  'GET_VENDOR_UNPAID_EVENT_REGISTRATIONS_SUCCESS';
export const GET_VENDOR_UNPAID_EVENT_REGISTRATIONS_FAILED =
  'GET_VENDOR_UNPAID_EVENT_REGISTRATIONS_FAILED';

export const GET_VENDOR_PAID_EVENT_REGISTRATIONS = 'GET_VENDOR_PAID_EVENT_REGISTRATIONS';
export const GET_VENDOR_PAID_EVENT_REGISTRATIONS_SUCCESS =
  'GET_VENDOR_PAID_EVENT_REGISTRATIONS_SUCCESS';
export const GET_VENDOR_PAID_EVENT_REGISTRATIONS_FAILED =
  'GET_VENDOR_PAID_EVENT_REGISTRATIONS_FAILED';
